export const hasKajabiAccess = (offers = []) => {
    const allowed = ["Pro Member", "Business Partners", "Healing – limited access", "Health & Fitness – limited access", "Leadership – limited access", "Beta Members", "Premium Member"]; // allowed tiers

    return offers.some((offer) =>
        allowed.includes(offer.attributes.internal_title)
    ); // check access
};

export const getUserKajabiPlans = (offers = []) => {
    return offers
        .map(offer => offer?.attributes?.internal_title)
        .filter(Boolean) // removes undefined/null
        .join(", ");
};